module.exports = __webpack_public_path__ + "static/media/21st-century-sadness.bf1b17b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/afc/21st-century-sadness.mp3
// module id = RRt7
// module chunks = 0